import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-email_us_page_submit_button-click';

/**
 * Event that tracks the &quot;Submit&quot; button being clicked in the &quot;Email us&quot; page for self-service. The first parameter is the issue chain that the user selected, in the format of ${issueL1}-${issueL2}-${issueL3}-${issueL4}
 */
export function trackCxFoundationsEmailUsPageSubmitButtonClick(
  issue_name_chain: string,
  retailerbrand_token2: string,
  email_address3: string = '',
  ticket_id4: string = '',
  brandOrderToken: string = '',
  user_name5: string = '',
  subject6: string = '',
  message7: string = '',
  email_address_from_input8: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      issue_name_chain,
      retailerbrand_token2,
      email_address3,
      ticket_id4,
      brandOrderToken,
      user_name5,
      subject6,
      message7,
      email_address_from_input8,
    },
  });
}
